import(/* webpackMode: "eager" */ "/home/runner/work/riteshvijaykumar.github.io/riteshvijaykumar.github.io/src/app/page.tsx");
